import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements as KDSStencilDefineCustomElements } from 'kds-stencil/dist/loader';
import { defineCustomElements as MXWebDefineCustomElements } from 'mx-web-components/dist/loader';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

KDSStencilDefineCustomElements(window);
MXWebDefineCustomElements(window);
